import React from 'react';
import { Separator } from './ui/separator';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../i18n/translations';
import { useConfig } from '../config/useConfig';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language].footer;
  const config = useConfig();

  return (
    <footer className="relative border-t border-border/50 bg-background/80 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Logo & Brand */}
        <div className="flex flex-col items-center text-center mb-8">
          <div className="mb-4">
            <div className="text-3xl font-bold tracking-wider text-primary">
              <span className="text-glow-divine">EH</span> // <span className="text-muted-foreground">MR</span>
            </div>
            <div className="text-sm text-muted-foreground tracking-widest mt-2">
              ECLIPSE HEAVEN × MOONLIGHT REWORKS
            </div>
          </div>

          <p className="text-muted-foreground max-w-md">
            {t.tagline}
          </p>
        </div>

        <Separator className="my-8 bg-border/30" />

        {/* Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h4 className="font-semibold text-foreground mb-3">{t.music}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href={config.links.spotifyArtist} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  Spotify
                </a>
              </li>
              <li>
                <a href={config.links.youtube} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  YouTube
                </a>
              </li>
              <li>
                <a href={config.links.appleMusic} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  Apple Music
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-3">{t.social}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href={config.links.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  Instagram
                </a>
              </li>
              <li>
                <a href={config.links.tiktok} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  TikTok
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-3">{t.contact}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href={`mailto:${config.links.bookingEmail}`} className="hover:text-primary transition-colors">
                  Booking
                </a>
              </li>
              <li>
                <a href={config.links.labelWebsite} target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                  Label
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-3">{t.legal}</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="#" className="hover:text-primary transition-colors">
                  {t.terms}
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primary transition-colors">
                  {t.privacy}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-border/30" />

        {/* Copyright */}
        <div className="text-center space-y-2">
          <p className="text-sm text-muted-foreground">
            {t.copyright}
          </p>
          <p className="text-xs text-muted-foreground/70">
            {t.aiDisclaimer}
          </p>
        </div>
      </div>

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'MusicGroup',
            name: 'Eclipse Heaven',
            genre: 'Cinematic Rock',
            foundingDate: '2025',
            description: language === 'en' 
              ? 'Cinematic rock opera where faith burns, resonates, rebuilds, and returns as echo.'
              : 'Ópera de rock cinematográfico donde la fe arde, resuena, reconstruye y regresa como eco.',
            recordLabel: {
              '@type': 'Organization',
              name: 'Moonlight Reworks',
              url: 'https://www.moonlightreworks.com',
            },
            album: [
              {
                '@type': 'MusicAlbum',
                name: 'Divine Fire',
                datePublished: '2025',
                numTracks: 12,
              },
              {
                '@type': 'MusicAlbum',
                name: 'The Resonant Soul',
                albumProductionType: 'http://schema.org/StudioAlbum',
                albumReleaseType: 'http://schema.org/AlbumRelease',
              },
            ],
          }),
        }}
      />
    </footer>
  );
};

export default Footer;